<template>
    <v-container class="fill-height" fluid >
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title v-t="'loginForm.title'"></v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="text--primary">
                        <v-form @keyup.enter.native="handleLogin">
                            <v-text-field ref="email" :errorMessages="emailErrors" prepend-icon="fas fa-user"
                                          :disabled="progress" v-model="email"
                                          name="login" :label="$t('loginForm.fields.email.label')" type="text"
                                          autocomplete="username"></v-text-field>

                            <v-text-field ref="password" :errorMessages="passwordErrors" prepend-icon="fas fa-key"
                                          :disabled="progress" v-model="password"
                                          name="password" :label="$t('loginForm.fields.password.label')" id="password"
                                          type="password" autocomplete="current-password"></v-text-field>
                        </v-form>
                        <v-alert
                                :value="commonErrors.length > 0"
                                color="error"
                                outlined
                        >
                            {{ commonErrors }}
                        </v-alert>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :loading="progress" @click="handleLoginButtonClick"
                               :disabled="progress">{{$t('loginForm.buttons.login.title')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import _ from 'lodash'
    import {mapActions, mapState, mapGetters} from 'vuex'

    export default {
        name: 'Login',
        components: {
        },
        data () {
            return {
                email: null,
                password: null,
            }
        },
        computed: {
            ...mapState({
                progress: 'auth/progress'
            }),
            ...mapGetters({
                isLoggedIn: 'auth/isLoggedIn',
                emailErrors: 'auth/loginEmailErrors',
                passwordErrors: 'auth/loginPasswordErrors',
                commonErrors: 'auth/loginCommonErrors'
            }),
        },
        methods: {
            ...mapActions({
                initApplication: 'initApplication',
                login: 'auth/login',
            }),
            async handleLoginButtonClick() {
                this.handleLogin()
            },
            async handleLogin () {
                await this.login({
                    email: this.email,
                    password: this.password,
                    language: this.$i18n.locale
                })

                if (this.isLoggedIn) {
                    await this.initApplication()
                }
            }
        }
    }
</script>

<style>
    .locale-changer .v-input__control {
        min-height: 40px !important;
    }
</style>